import axios from 'axios';
import { BrandItem, UpdateBrandParams } from 'types';

export const fetchBrand = (brandId: number) =>
  axios.get<BrandItem>(`/api/brands/${brandId}`);

export const updateBrand = (brandId: number, data: UpdateBrandParams) =>
  axios.post(`/api/brands/${brandId}`, data);
